<script setup>

const props = defineProps({
	active: Boolean,
	visible: Boolean,
	color: String,
})

</script>

<template >
	<svg width="12" height="20" viewBox="0 0 12 20" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M11.0601 0.550059C11.4401 0.940059 11.4401 1.57006 11.0601 1.96006L3.1901 9.83006L11.0601 17.7001C11.4501 18.0901 11.4501 18.7201 11.0601 19.1101C10.6701 19.5101 10.0301 19.5101 9.6401 19.1101L0.350098 9.83006L9.6401 0.540059C10.0301 0.150059 10.6701 0.150059 11.0601 0.540059V0.550059Z"
			:fill="`rgb(var(--color-${color}) / 1)`"
			:stroke="`rgb(var(--color-${color}) / 1)`"
			stroke-width="0.5" stroke-miterlimit="10"
		/>
	</svg>
</template>